'use strict';

import React, { Component, createRef } from 'react';
import uniqid from 'uniqid';
import SearchResultsMap from 'Components/Front/SearchResultsMap';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import MapDetailsBlock from 'Components/Front/MapDetailsBlock';
import bemit from 'Functions/bemit';
import truncate from 'Functions/truncate';
import isPartiallyinViewport from 'Functions/isPartiallyinViewport';
import { action } from 'Shared/Routes';
const {
  app,
  qwest
} = window;
export default class EtablishmentsMapBlock extends Component {
  state = {
    search_id: uniqid(),
    ready: false
  };
  ref = createRef();
  first_fetch = false;
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'clickedMapEtablishment',
      cb: component.handleEtablishmentClick
    });
    component.fetch();
    if (props.autoload || isPartiallyinViewport(component.ref?.current)) {
      component.setState({
        ready: true
      });
    } else {
      window.setTimeout(component.readyTimeout, 500);
    }
  }
  readyTimeout = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.ready || !component.ref?.current) return;
    if (isPartiallyinViewport(component.ref.current)) {
      component.setState({
        ready: true
      });
    } else {
      window.setTimeout(component.readyTimeout, 500);
    }
  };
  handleEtablishmentClick = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!data.etablishment) return;
    component.fetchDetails(data.etablishment);
  };
  fetch = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    const url = action('getAllFrontEtablishments');
    qwest.post(url, {
      limit: 0,
      skip: 0,
      front_page_order: false,
      type: app.state.session.user?.roles?.includes?.('company_employee') ? 'coworking' : undefined,
      source: 'EtablishmentsMapBlock',
      searched: '',
      order: 'asc',
      order_by: 'front_page_order'
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        data_count: response.count || 0,
        data: (response.data || []).map(function (data) {
          data.description = truncate(data.description, 160);
          return data;
        }),
        width: window.innerWidth,
        render_id: uniqid()
      });
      component.handleFetch({
        data: response.data || []
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchDetails = etablishment => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('fetchEstablishmentDetails'), {
      etablishment_id: etablishment.id,
      source: 'EtablishmentsMapBlock'
    }).then(function (xhr, response) {
      component.setState({
        selected_etablishment: {
          ...response.establishment
        },
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleFetch = ({
    data = []
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.first_fetch = true;
    component.setState({
      etablishments: data,
      map_id: uniqid()
    });
  };
  onMapChange = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.selected_etablishment) {
      component.setState({
        selected_etablishment: undefined
      });
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement("section", {
      className: "page-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit('o-section', ['map'])
    }, /*#__PURE__*/React.createElement("h2", {
      className: "c-title u-full-width"
    }, "myWO en France"), /*#__PURE__*/React.createElement("div", {
      className: "search-results-map-container\r search-results-map-container--home",
      ref: component.ref
    }, state.ready && state.map_id ? /*#__PURE__*/React.createElement(SearchResultsMap, {
      home: true,
      "disable-tooltip": true,
      etablishments: state.etablishments,
      "auto-scroll": true,
      autoload: true
    }) : undefined, /*#__PURE__*/React.createElement(MapDetailsBlock, {
      onChange: component.onMapChange,
      etablishment: state.selected_etablishment
    }))));
    return output;
  }
}
